module.exports = __webpack_public_path__ + "img/2.5.COD.7db62c24.png";